// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"21751828787cd535","5405":"61fed6e93d118b0d","9413":"4ecf317cf4f9a6ed"}[chunkId] + ".css";
};